export const grid = {
  columns: 12,
};
